import {
    ADD_BOOK,
    FEATURED_BOOKS,
    LOADED_BOOKS,
    REMOVE_BOOK,
    SEARCH_BOOKS,
    SET_BOOK,
    UPDATE_BOOK,
} from "./actionTypes";

const initialState = {
  books: [],
  allbooks: [],
  book: null,
  showFeatured: false,
};

export default function booksReducer(state = initialState, action) {
  switch (action.type) {
    case LOADED_BOOKS:
      return {
        ...state,
        books: action.payload,
        allbooks: action.payload,
        showFeatured: false,
      };
    case ADD_BOOK:
      return {
        ...state,
        books: [
          ...state.books,
          {
            ...action.payload,
            id: state.books.length + 2,
          },
        ],
        allbooks: [
          ...state.allbooks,
          {
            ...action.payload,
            id: state.books.length + 2,
          },
        ],
      };
    case REMOVE_BOOK:
      return {
        ...state,
        books: state.books.filter((book) => book.id !== action.payload),
        allbooks: state.allbooks.filter((book) => book.id !== action.payload),
      };
    case UPDATE_BOOK:
      return {
        ...state,
        books: state.books.map((book) =>
          book.id === action.payload.id ? action.payload : book
        ),
        allbooks: state.allbooks.map((book) =>
          book.id === action.payload.id ? action.payload : book
        ),
        book: null,
      };
    case FEATURED_BOOKS:
      return {
        ...state,
        books: state.books.filter((book) => book.featured === true),
        showFeatured: true,
      };
    case SET_BOOK:
      return {
        ...state,
        book: action.payload,
      };
    case SEARCH_BOOKS:
      return {
        ...state,
        books: state.allbooks.filter((book) =>
          book.name.toLowerCase().includes(action.payload.toLowerCase())
        ),
      };
    default:
      return state;
  }
}
